// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#root input {\r\n  outline: none;\r\n}\r\n\r\n.gm-style a {\r\n  display: none !important;\r\n}\r\n\r\n.gmnoprint {\r\n  display: none;\r\n}", ""]);
// Exports
module.exports = exports;
